<div class="over-ask-pick-list-card">
    @if (shouldShowHeader()) {
        <div class="over-ask-sgp-combo-bet-header__title">
            <div class="over-ask-sgp-header-name">{{ title }}</div>
            <div class="over-ask-combo-sgp-pick-count">{{ legsCount }}</div>
            @if (isPendingState()) {
                <div class="over-ask-combo-bet-header__odds">{{ formattedOdds(totalOdds) }}</div>
            } @else if (isReviewState()) {
                <div class="over-ask-combo-bet-header__odds">
                    @if (hasOddsChange) {
                        <span class="over-ask-combo-bet-header__odds--old">{{ formattedOdds(totalOdds) }}</span>
                    }
                    <span>{{ formattedOdds(changedTotalOdds) }}</span>
                </div>
            }
        </div>
    }

    <bs-digital-over-ask-pick-selector
        class="betslip-over-ask-pick-container"
        *ngFor="let pickVM of pickViewModel"
        [props]="pickVM"
        [overAskFlowState]="overAskFlowState"
        [isMultiSingle]="isMultiSingle()"
        [oddsDisplayFormat]="oddsDisplayFormat"></bs-digital-over-ask-pick-selector>
</div>
